/**
 * WhatsAppButton.js — Floating WhatsApp button, visible on all pages.
 * Uses inline styles for the critical styles so it renders regardless of Tailwind purge.
 */
import React, { useState } from 'react';

const WA_NUMBER  = '916374801083'; // Replace with real number: country code + number, no +
const WA_MESSAGE = encodeURIComponent(
  'Hi Lakshmi Crackers! 🎆 I am interested in your products. Please share more details about the available offers and combo packs.'
);
const WA_URL = `https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`;

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  return (
    <div style={{
      position: 'fixed',
      bottom: '24px',
      right: '20px',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    }}>
      {/* Tooltip */}
      <div style={{
        background: '#1f2937',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 600,
        padding: '8px 14px',
        borderRadius: '12px',
        whiteSpace: 'nowrap',
        boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
        opacity: hovered ? 1 : 0,
        transform: hovered ? 'translateX(0)' : 'translateX(12px)',
        transition: 'all 0.25s ease',
        pointerEvents: 'none',
        position: 'relative',
      }}>
        Chat with us on WhatsApp 💬
        {/* Arrow pointing right */}
        <div style={{
          position: 'absolute',
          top: '50%',
          right: '-5px',
          transform: 'translateY(-50%) rotate(45deg)',
          width: '10px',
          height: '10px',
          background: '#1f2937',
        }}/>
      </div>

      {/* WhatsApp button */}
      <a
        href={WA_URL}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '58px',
          height: '58px',
          borderRadius: '50%',
          backgroundColor: '#25D366',
          boxShadow: hovered
            ? '0 6px 28px rgba(37,211,102,0.7)'
            : '0 4px 18px rgba(37,211,102,0.5)',
          transform: hovered ? 'translateY(-3px) scale(1.05)' : 'translateY(0) scale(1)',
          transition: 'all 0.3s ease',
          textDecoration: 'none',
          position: 'relative',
          flexShrink: 0,
        }}>

        {/* Pulsing ring */}
        <span style={{
          position: 'absolute',
          inset: 0,
          borderRadius: '50%',
          background: 'rgba(37,211,102,0.4)',
          animation: 'wa-ping 2s cubic-bezier(0,0,0.2,1) infinite',
        }}/>

        {/* WhatsApp SVG */}
        <svg
          viewBox="0 0 24 24"
          fill="white"
          style={{ width: '30px', height: '30px', position: 'relative', zIndex: 1 }}>
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
      </a>

      {/* Keyframe animation injected into head */}
      <style>{`
        @keyframes wa-ping {
          0%   { transform: scale(1);   opacity: 0.6; }
          70%  { transform: scale(1.5); opacity: 0;   }
          100% { transform: scale(1.5); opacity: 0;   }
        }
      `}</style>
    </div>
  );
}
